<div class="dialog-backdrop" *ngIf="isOpen">
  <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="privacy-policy-title">
    <header class="dialog-header">
      <h2 id="privacy-policy-title">Privacy Policy Summary</h2>
      <button type="button" class="close-button" (click)="close()" aria-label="Close privacy policy dialog">×</button>
    </header>
    <div class="dialog-body">
      <p>
        ClariChat uses Google sign-in and optional Google Docs/Drive integrations to help you collaborate on AI-generated
        content. We access only the scopes you approve, such as your email address and files you choose to open or save.
      </p>
      <p>
        We use Google user data to authenticate your account, sync documents, and personalize your workspace. Content you
        create or import may be stored in our Firebase-backed databases and cloud storage so you can resume work across
        devices.
      </p>
      <p>
        We do not sell your Google user data. We share it only with trusted service providers (hosting, authentication,
        analytics) required to operate ClariChat and protect your information.
      </p>
      <p>
        You can request deletion of your data at any time. For the complete policy, open the public Privacy Policy page.
      </p>
      <div class="dialog-actions">
        <a class="primary-link" routerLink="/iq/privacy-policy" (click)="close()">Read the full Privacy Policy</a>
      </div>
    </div>
  </div>
</div>
